import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  FieldBaseWrapper
} from './styled'

export class FieldBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      label,
      labelFontStyle,
      labelFontColor,
      labelAlign,
      labelWidth,
      labelSpacingTop,
      labelSpacingRight,
      fluid,
      error,
      success,
      disabled,
      width,
      height,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      bgColor,
      borderWidth,
      borderStyle,
      borderColor,
      borderBottomWidth,
      borderBottomStyle,
      borderBottomColor,
      borderRadius,
      fontStyle,
      fontColor,
      fontLineHeight,
      textAlign,
      placeholder,
      placeholderColor,
      errorColor,
      successColor,
      disabledColor,
      fieldIcon,
      fieldIconWidth,
      fieldIconSpacingLeft,
      fieldIconSpacingRight,
      fieldIconActive,
      onClickFieldIcon,
      type,
      inputTextType,
      checkboxSize,
      checkboxBgColor,
      checkboxCheckedBgColor,
      checkboxBorderWidth,
      checkboxBorderStyle,
      checkboxBorderColor,
      checkboxBorderCheckedColor,
      checkboxBorderRadius,
      checkboxCheckedIcon,
      checkboxLabel,
      checkboxLabelFontStyle,
      checkboxLabelSpacingLeft,
      checkboxLabelFontColor,
      checkboxLabelCheckedFontColor,
      radioSize,
      radioBgColor,
      radioCheckedBgColor,
      radioBorderWidth,
      radioBorderStyle,
      radioBorderColor,
      radioBorderCheckedColor,
      radioBorderRadius,
      radioCheckedIcon,
      radioLabel,
      radioLabelFontStyle,
      radioLabelSpacingLeft,
      radioLabelFontColor,
      radioLabelCheckedFontColor,
      fileName,
      fileImage,
      fileImageSpacingBottom,
      buttonBrowse,
      buttonBrowseSpacingLeft,
      buttonUpload,
      buttonUploadSpacingLeft,
      buttonDeleteUpload,
      buttonDeleteUploadSpacingLeft,
      id,
      name,
      value,
      checked,
      accept,
      onChange,
      onBlur,
      onFocus,
      message,
      messageFontStyle,
      messageFontColor,
      messageSpacingTop,
      messageSpacingLeft,
      messageAlign,
      hint,
      hintFontStyle,
      hintFontColor,
      hintSpacingTop,
      hintSpacingLeft,
      info,
      switchWidth,
      switchHeight,
      switchBgColor,
      switchActiveBgColor,
      switchBorderWidth,
      switchBorderStyle,
      switchBorderColor,
      switchBorderRadius,
      switchButtonSpacingLeft,
      switchButtonSpacingRight,
      switchButtonSize,
      switchButtonInactiveColor,
      switchButtonActiveColor,
      switchButtonShadow,
      switchNameFontStyle,
      switchNameOuterFontStyle,
      switchNameOuterSpacingLeft,
      switchName,
      switchOuterName,
      maxLength,
      isLimitWidthLabel
    } = this.props

    return (
      <FieldBaseWrapper
        className={ClassNames(
          'field-base',
          { 'is-fluid': fluid },
          { 'is-error': error },
          { 'is-success': success },
          { 'is-disabled': disabled },
          { 'is-info': info },
          // Option
          className
        )}
        theme={{
          // Default
          labelFontStyle,
          labelFontColor,
          labelAlign,
          labelWidth,
          labelSpacingTop,
          labelSpacingRight,
          width,
          height,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          bgColor,
          borderWidth,
          borderStyle,
          borderColor,
          borderBottomWidth,
          borderBottomStyle,
          borderBottomColor,
          borderRadius,
          fontStyle,
          fontColor,
          fontLineHeight,
          textAlign,
          placeholderColor,
          errorColor,
          successColor,
          disabledColor,
          fieldIcon,
          fieldIconWidth,
          fieldIconSpacingLeft,
          fieldIconSpacingRight,
          checkboxSize,
          checkboxBgColor,
          checkboxCheckedBgColor,
          checkboxBorderWidth,
          checkboxBorderStyle,
          checkboxBorderColor,
          checkboxBorderCheckedColor,
          checkboxBorderRadius,
          checkboxLabelFontStyle,
          checkboxLabelSpacingLeft,
          checkboxLabelFontColor,
          checkboxLabelCheckedFontColor,
          radioSize,
          radioBgColor,
          radioCheckedBgColor,
          radioBorderWidth,
          radioBorderStyle,
          radioBorderColor,
          radioBorderCheckedColor,
          radioBorderRadius,
          radioLabelFontStyle,
          radioLabelSpacingLeft,
          radioLabelFontColor,
          radioLabelCheckedFontColor,
          fileImageSpacingBottom,
          buttonBrowseSpacingLeft,
          buttonUploadSpacingLeft,
          buttonDeleteUploadSpacingLeft,
          messageFontStyle,
          messageFontColor,
          messageSpacingTop,
          messageSpacingLeft,
          messageAlign,
          hintFontStyle,
          hintFontColor,
          hintSpacingTop,
          hintSpacingLeft,
          switchWidth,
          switchHeight,
          switchBgColor,
          switchActiveBgColor,
          switchBorderWidth,
          switchBorderStyle,
          switchBorderColor,
          switchBorderRadius,
          switchButtonSpacingLeft,
          switchButtonSpacingRight,
          switchButtonSize,
          switchButtonInactiveColor,
          switchButtonActiveColor,
          switchButtonShadow,
          switchNameFontStyle,
          switchNameOuterFontStyle,
          switchNameOuterSpacingLeft
        }}
      >
        <div className='field-container-base'>
          {label &&
            <label className='field-label-base'>
              {label}
            </label>
          }
          <div className='field-group-base'>
            <div className='field-group-inner-base'>
              {/* Select field element */}
              {(() => {
                switch (type) {
                  case 'textarea':
                    return (
                      <textarea
                        className='field-value-base'
                        placeholder={placeholder}
                        id={id}
                        name={name}
                        value={value}
                        onChange={onChange}
                        maxLength={maxLength}
                      />
                    )
                  case 'select':
                    return (
                      <select
                        className='field-value-base'
                        id={id}
                        name={name}
                        value={value}
                        onChange={onChange}
                      >
                        {children}
                      </select>
                    )
                  case 'checkbox':
                    return (
                      <div className='field-checkbox-base'>
                        <input className='field-checkbox-value-base'
                          type='checkbox'
                          id={id}
                          name={name}
                          value={value}
                          checked={checked}
                          onChange={onChange}
                        />
                        <label className='field-checkbox-label-base'
                          htmlFor={id}
                        >
                          <span className='field-checkbox-icon-base'>
                            <span className='field-checkbox-icon-checked-base'>
                              {checkboxCheckedIcon}
                            </span>
                          </span>
                          {checkboxLabel &&
                            <span className={`field-checkbox-icon-label-base ${isLimitWidthLabel && 'max-width-limit'}`}
                            >
                              {checkboxLabel}
                            </span>
                          }
                        </label>
                      </div>
                    )
                  case 'radio':
                    return (
                      <div className='field-radio-base'>
                        <input className='field-radio-value-base'
                          type='radio'
                          id={id}
                          name={name}
                          value={value}
                          checked={checked}
                          onChange={onChange}
                        />
                        <label className='field-radio-label-base'
                          htmlFor={id}
                        >
                          <span className='field-radio-icon-base'>
                            <span className='field-radio-icon-checked-base'>
                              {radioCheckedIcon}
                            </span>
                          </span>
                          {radioLabel &&
                            <span className='field-radio-icon-label-base'>
                              {radioLabel}
                            </span>
                          }
                        </label>
                      </div>
                    )
                  case 'file':
                    return (
                      <div className='field-file-base'>
                        <div className='field-file-name-base'>
                          <span className='field-file-name-text-base'>
                            {fileName}
                          </span>
                        </div>
                        <div className='field-file-button-base'>
                          <input className='field-file-input-base'
                            type='file'
                            id={id}
                            name={name}
                            value={value}
                            onChange={onChange}
                            accept={accept}
                          />
                          <div className='field-file-button-browse-base'>
                            {buttonBrowse}
                          </div>
                        </div>
                        <div className='field-file-button-upload-base'>
                          {buttonUpload}
                        </div>
                      </div>
                    )
                  case 'fileAvatar':
                    return (
                      <div className='field-file-base is-avatar'>
                        <div className='field-file-image-base'>
                          {fileImage}
                        </div>
                        <div className='field-file-button-group-base'>
                          <div className='field-file-button-base'>
                            <input className='field-file-input-base'
                              type='file'
                              id={id}
                              name={name}
                              value={value}
                              onChange={onChange}
                              accept={accept}
                            />
                            <div className='field-file-button-browse-base'>
                              {buttonBrowse}
                            </div>
                          </div>
                          <div className='field-file-button-delete-upload-base'>
                            {buttonDeleteUpload}
                          </div>
                        </div>
                      </div>
                    )
                  case 'uploadImage':
                    return (
                      <div className='field-file-base is-avatar'>
                        <div className='field-file-image-relative-base width-full'>
                          {fileImage}
                          <div className='field-file-button-delete-upload-in-image-base'>
                            {buttonDeleteUpload}
                          </div>
                        </div>
                        <div className='field-file-button-group-base'>
                          <div className='field-file-button-base'>
                            <input className='field-file-input-base'
                              type='file'
                              id={id}
                              name={name}
                              value={value}
                              onChange={onChange}
                              accept={accept}
                            />
                            <div className='field-file-button-browse-base'>
                              {buttonBrowse}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  case 'info':
                    return (
                      <div className='field-info-base'>
                        <span className='field-info-text-base'>
                          {info}
                        </span>
                      </div>
                    )
                  case 'switch':
                    return (
                      <div className='field-switch-base'>
                        <input className='field-switch-input-base'
                          type='checkbox'
                          id={id}
                          name={name}
                          value={value}
                          checked={checked}
                          onChange={onChange}
                        />
                        <label className='field-switch-body-base'
                          htmlFor={id}
                        >
                          <span className='field-switch-button-base' />
                          {switchName &&
                            <span className='field-switch-name-base'>
                              {switchName}
                            </span>
                          }
                        </label>
                        {switchOuterName &&
                          <span className='field-switch-name-outer-base'>
                            {switchOuterName}
                          </span>
                        }
                      </div>
                    )
                  default:
                    return (
                      <input
                        className='field-value-base'
                        type={inputTextType}
                        placeholder={placeholder}
                        id={id}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        maxLength={maxLength}
                      />
                    )
                }
              })()}
              {fieldIcon &&
                <div
                  className={ClassNames(
                    'field-icon-base',
                    { 'is-cursor-pointer': onClickFieldIcon }
                  )}
                  onClick={onClickFieldIcon}
                  onKeyDown={() => { }}
                  tabIndex={0}
                  role='button'
                >
                  {fieldIconActive ?
                    fieldIconActive
                    :
                    fieldIcon
                  }
                </div>
              }
            </div>
            {message &&
              <div className='field-message-base'>
                {message}
              </div>
            }
          </div>
          {hint &&
            <div className='field-hint-base'>
              {hint}
            </div>
          }
        </div>
      </FieldBaseWrapper>
    )
  }

  static defaultProps = {
    inputTextType: 'text',
    bgColor: VARIABLES.COLORS.WHITE,
    errorColor: VARIABLES.COLORS.ERROR,
    successColor: VARIABLES.COLORS.SUCCESS,
    disabledColor: VARIABLES.COLORS.DISABLED,
    switchButtonInactiveColor: VARIABLES.COLORS.WHITE,
    switchButtonActiveColor: VARIABLES.COLORS.WHITE
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    label: PropTypes.string,
    labelFontStyle: PropTypes.any,
    labelFontColor: PropTypes.string,
    labelAlign: PropTypes.string,
    labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    labelSpacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    labelSpacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fluid: PropTypes.bool,
    error: PropTypes.bool,
    success: PropTypes.bool,
    disabled: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bgColor: PropTypes.string,
    borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderBottomWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomStyle: PropTypes.string,
    borderBottomColor: PropTypes.string,
    borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fontStyle: PropTypes.any,
    fontColor: PropTypes.string,
    fontLineHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAlign: PropTypes.string,
    placeholder: PropTypes.string,
    placeholderColor: PropTypes.string,
    errorColor: PropTypes.string,
    successColor: PropTypes.string,
    disabledColor: PropTypes.string,
    fieldIcon: PropTypes.any,
    fieldIconWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fieldIconSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fieldIconSpacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fieldIconActive: PropTypes.string,
    onClickFieldIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    type: PropTypes.string,
    inputTextType: PropTypes.string,
    checkboxSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkboxBgColor: PropTypes.string,
    checkboxCheckedBgColor: PropTypes.string,
    checkboxBorderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkboxBorderStyle: PropTypes.string,
    checkboxBorderColor: PropTypes.string,
    checkboxBorderCheckedColor: PropTypes.string,
    checkboxBorderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkboxCheckedIcon: PropTypes.any,
    checkboxLabel: PropTypes.string,
    checkboxLabelFontStyle: PropTypes.any,
    checkboxLabelSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkboxLabelFontColor: PropTypes.string,
    checkboxLabelCheckedFontColor: PropTypes.string,
    radioSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radioBgColor: PropTypes.string,
    radioCheckedBgColor: PropTypes.string,
    radioBorderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radioBorderStyle: PropTypes.string,
    radioBorderColor: PropTypes.string,
    radioBorderCheckedColor: PropTypes.string,
    radioBorderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radioCheckedIcon: PropTypes.string,
    radioLabel: PropTypes.string,
    radioLabelFontStyle: PropTypes.string,
    radioLabelSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    radioLabelFontColor: PropTypes.string,
    radioLabelCheckedFontColor: PropTypes.string,
    fileName: PropTypes.string,
    fileImage: PropTypes.string,
    fileImageSpacingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonBrowse: PropTypes.string,
    buttonBrowseSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonUpload: PropTypes.string,
    buttonUploadSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonDeleteUpload: PropTypes.string,
    buttonDeleteUploadSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checked: PropTypes.bool,
    onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    onBlur: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    onFocus: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    message: PropTypes.any,
    messageFontStyle: PropTypes.string,
    messageFontColor: PropTypes.string,
    messageSpacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    messageSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    messageAlign: PropTypes.string,
    hint: PropTypes.string,
    hintFontStyle: PropTypes.string,
    hintFontColor: PropTypes.string,
    hintSpacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hintSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    info: PropTypes.bool,
    switchWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchBgColor: PropTypes.string,
    switchActiveBgColor: PropTypes.string,
    switchBorderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchBorderStyle: PropTypes.string,
    switchBorderColor: PropTypes.string,
    switchBorderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchButtonSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchButtonSpacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchButtonSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchButtonInactiveColor: PropTypes.string,
    switchButtonActiveColor: PropTypes.string,
    switchButtonShadow: PropTypes.string,
    switchNameFontStyle: PropTypes.string,
    switchNameOuterFontStyle: PropTypes.string,
    switchNameOuterSpacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    switchName: PropTypes.string,
    switchOuterName: PropTypes.string,
    maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
